import React from 'react'
import "./CheckoutProduct.css"
import {useStateValue} from "./StateProvider";
function Checkoutproduct({id,title,image,price,rating}) {
    const [{basket},dispatch] = useStateValue();
    const removeFromBasket=()=>{
        dispatch({
            type :"REMOVE_FROM_BASKET",
            id : id,

        });

    }
    return (
        <div className="checkoutproduct">
            <img className="checkoutproduct_image" src={image} alt=""/>
            <div className ="checkoutproduct_image" className="Checkoutproduct_info">
                <p className="Checkoutproduct_title"> {title}</p>
                <p className="Checkoutproduct_price">
                    <small> &</small>
                    <strong>
                        {price}
                    </strong>
                </p>
                <div className="Checkoutproduct_rating">
                {
                    Array(rating)
                    .fill()
                    .map((_)=>(
                        <p>⭐</p>
                    ))}
            </div>
            <button onClick={removeFromBasket}> REMOVE from basket</button>

        </div>
        </div>
    );
}

export default Checkoutproduct
